
import ReactDOM from 'react-dom';
import ApolloProvider from './ApolloProvider';
import reportWebVitals from './reportWebVitals.js';
import './index.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(ApolloProvider,document.getElementById('root'));


serviceWorker.unregister();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();